export enum ApplicationActEnum {
  MENU_TOGGLE = '@application/MENU_TOGGLE',
  MENU_MOBILE_TOGGLE = '@application/MENU_MOBILE_TOGGLE',
  STEP_WIDGET = '@application/STEP_WIDGET',
  SET_DATE_RANGE = '@application/SET_DATE_RANGE',
}
